import { Address } from './address.model';

export class ProcessingInvoice {
  dateOfService!: string;
  location!: Address;
  locationName?: string;
  number!: string;
  patientName?: string;
}
